import { useEffect } from 'react'
import Dialog from '@mui/material/Dialog'
import ThanksImage from '../../../assets/icon/classreview-thanks.png'

const ThanksModal = ({ isOpen, setIsOpen }) => {
  const handleClose = () => {
    setIsOpen(false)
  }

  console.log(isOpen)
  useEffect(() => {
    return () => {
      handleClose()
    }
  }, [])

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'md:!max-w-[420px] !p-[24px] !rounded-[12px] !bg-[#FDFDFD] !shadow-modal',
      }}
    >
      <div className="w-full flex flex-col items-center justify-center">
        <img src={ThanksImage} alt="Success" className="w-[124px] h-[124px]" />

        <h2 className="text-xl font-bold text-primary-100 mt-[16px] text-center">
          Thank You for Your Review!
        </h2>

        <h3 className="mt-[8px] text-sm font-medium text-primary-100 text-center">
          We appreciate you taking the time to share your experience with us. Your feedback will
          prove to be valuable in helping us improve.
        </h3>

        <button
          className="mt-[24px] w-full h-[44px] flex items-center justify-center shadow-button bg-[#F79009] rounded-lg text-lg font-semibold text-white"
          onClick={handleClose}
        >
          Continue
        </button>
      </div>
    </Dialog>
  )
}

export default ThanksModal
